import { Button, Typography } from '@mui/material';
import { PATH_ROOT } from 'constants/api';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function ConflictCustomerCode(props) {
    const { email } = props.SSOInfo
    const navigate = useNavigate();
    const { t } = useTranslation();
    const provider = props.provider

    useEffect(() => {
        if (!email) {
            navigate(`${PATH_ROOT}/auth/register`)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <Typography fontWeight={600} fontSize={28} textAlign={'center'} mb={3}>{t('dialog.conflict-customer-code.title')}</Typography>
            <div className="body-create-account">
                <Typography className='create-account-intro'>
                    {t('dialog.conflict-customer-code.email')} <b>{email}</b>{t('dialog.conflict-customer-code.intro', { provider: t(`auth.${provider}`) })}
                </Typography>
                <div className="create-account-button">
                    <span>
                        <Button
                            size="large"
                            type={'submit'}
                            variant="contained"
                            sx={{ mt: 1, mb: 1.5}}
                            onClick={() => navigate(`${PATH_ROOT}/auth/login`)}
                            fullWidth
                        >
                            {t('dialog.conflict-customer-code.login')}
                        </Button>
                    </span>
                </div>
            </div>
        </>
    );
}
